import {Pipe, PipeTransform, inject} from '@angular/core';
import * as moment from 'moment-timezone';
import {CurrentSkedTask} from 'src/app/core/model/task';
import {TimezoneService} from 'src/app/services/timezone.service';

@Pipe({
  name: 'isTaskExpired',
  standalone: true,
})
export class IsTaskExpiredPipe implements PipeTransform {
  private readonly timezoneService = inject(TimezoneService);

  transform(task: CurrentSkedTask | null | undefined): boolean {
    if (!task?.endDateTime) {
      return false;
    }

    return moment()
      .tz(this.timezoneService.getTimeZone())
      .isAfter(moment(task.endDateTime).tz(this.timezoneService.getTimeZone()));
  }
}
